/** Locale-aware copy helpers; the legacy module name remains for callers. */
import i18n, { t } from 'i18n';
import { formatDate, formatNumber } from 'i18n/format';

/** Compatibility for callers supplying one/few/many word forms. */
export function plural(n, [one, few, many]) {
  const category = new Intl.PluralRules(i18n.resolvedLanguage || 'ru').select(n);
  return category === 'one' ? one : category === 'few' ? few : many;
}

export const clock = (date) => formatDate(date, { hour: '2-digit', minute: '2-digit' });
const sameDay = (a, b) => a.toDateString() === b.toDateString();

export function whenLabel(iso, now = new Date()) {
  if (!iso) return '—';
  const date = new Date(iso);
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  const tomorrow = new Date(now);
  tomorrow.setDate(now.getDate() + 1);
  const time = clock(date);
  if (sameDay(date, now)) return t('data.todayAt', { time });
  if (sameDay(date, yesterday)) return t('data.yesterdayAt', { time });
  if (sameDay(date, tomorrow)) return t('data.tomorrowAt', { time });
  return t('data.dateAtTime', { date: formatDate(date, { day: 'numeric', month: 'short' }), time });
}

export const whenInline = (iso, now) => {
  const label = whenLabel(iso, now);
  return label.charAt(0).toLowerCase() + label.slice(1);
};

export const fmtNumber = (n) => formatNumber(n ?? 0);
export const countLabel = (n, noun) => t(`data.${noun}Count`, { count: n ?? 0, amount: fmtNumber(n) });
export const rowsLabel = (n) => countLabel(n, 'row');

export function durationLabel(start, end) {
  if (!start || !end) return '—';
  const seconds = Math.max(0, Math.round((new Date(end) - new Date(start)) / 1000));
  const minutes = Math.floor(seconds / 60);
  if (seconds < 60) return t('data.durationSeconds', { count: seconds, amount: fmtNumber(seconds) });
  if (minutes < 60) return t('data.durationMinutesSeconds', { minutes: fmtNumber(minutes), seconds: fmtNumber(seconds % 60) });
  return t('data.durationHoursMinutes', { hours: fmtNumber(Math.floor(minutes / 60)), minutes: fmtNumber(minutes % 60) });
}
